<template>
    <SignUpConfirm />
</template>

<script>
import SignUpConfirm from "@/components/SignUpConfirm.vue";

export default {
    name: 'SignUpConfirmView',
    components: {
        SignUpConfirm
    }
}
</script>
